// extracted by mini-css-extract-plugin
export default {"wrapper":"tS-z","availablePromoMessagesLabel":"uS-z","promoMessageList":"vS-z","promoMessage":"wS-z","appliedPromoMessage":"xS-z","promoMessageAmount":"yS-z"};